<template>
  <div class="ComfirmOrder">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>创建对账单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <div class="title">对账清单</div>
      <template v-for="(item, index) in materialList">
        <div :key="index">
          <div class="title">{{ item.CompanyName }}</div>
          <div>
            <el-table :data="item.ItemList" class="table_wrap1" border show-summary :summary-method="getSummaries">
              <el-table-column prop="OrderNumber" label="订单编号" width="250px"></el-table-column>
              <el-table-column prop="MaterialCode" label="物品代码"></el-table-column>
              <el-table-column prop="MaterialName" label="物品名称"></el-table-column>
              <el-table-column prop="Specification" label="品牌规格"></el-table-column>
              <el-table-column prop="ActualCount" label="采购数量"></el-table-column>
              <el-table-column prop="InvoiceCount" label="实际到货数"></el-table-column>
              <el-table-column prop="CancelCount" label="取消数"></el-table-column>
              <el-table-column prop="InvoiceCount" label="对账数"></el-table-column>

              <el-table-column prop="PerPrice" label="单价（元）"></el-table-column>
              <el-table-column prop="SumFee" label="金额（元）"></el-table-column>
              <el-table-column prop="Remark" label="备注"></el-table-column>
            </el-table>
          </div>
        </div>
      </template>
      <div class="title">发货单附件</div>
      <div>
        <el-form :inline="true" :model="model" class="form_table" ref="form" :inline-message="true">
          <el-form-item label="发货单">
            <el-upload
              action="#"
              :before-remove="removeConfirm"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :on-change="fileChange"
              :on-success="handleSuccess"
              :on-error="handleError"
              :auto-upload="true"
              :file-list="fileList"
              :http-request="uploadTechnicalFile"
              accept=".pdf"
              ref="uploader"
            >
              <el-button size="mini" type="primary" plain>点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn_wrap changeInform_btn_wrap">
        <span class="btn_1" @click="fnGoBack()">返回</span>
        <span class="btn_1" @click="fnSave()">提交</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      materialList: [],
      fileList: [],
      model: {}
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let config = {
        params: {
          orderId: this.$route.query.orderId,
          reconciliationId: this.$route.query.reconciliationId
        }
      }
      this.getRequest('/Order/GetReconciliationData', config).then((res) => {
        if (res.data.errcode == 0) {
          this.materialList = res.data.materialList
          this.fileList = res.data.fileList
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },

    fnGoBack() {
      window.close()
    },

    fnSave() {
      let that = this
      var flag = true
      if (that.fileList.length == 0) {
        this.$message.error('请先上传发货单附件！')
        flag = false
      }
      if (flag == true) {
        let materialListJson = JSON.stringify(that.materialList)
        this.postRequest('/Order/CreateReconciliation', {
          orderId: this.$route.query.orderId,
          reconciliationId: this.$route.query.reconciliationId,
          fileListJson: JSON.stringify(that.fileList)
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.$message.success('提交成功')
            localStorage.setItem('reconciliationList', Math.random())
            localStorage.setItem('orderList', Math.random())
            setTimeout(() => {
              window.close()
            }, 1000)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    uploadTechnicalFile(params) {
      console.log(params)
      let file = params.file
      var data = new window.FormData()
      let loginToken = window.localStorage.getItem('loginToken')
      data.append('file', params.file)
      data.append('loginToken', loginToken)
      this.uploadFileRequest('/Common/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          var obj = {
            fileId: res.data.FileList[0].id,
            name: res.data.FileList[0].fileName,
            status: 'success'
          }
          if (this.fileList.length == 0) {
            this.fileList = [obj]
          } else {
            this.fileList.push(obj)
          }
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },

    // 文件状态改变时的钩子
    fileChange(file, fileList) {},
    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList) {
      if (file.hasOwnProperty('fileId')) {
        this.postRequest('/Common/DeleteAttachmentByFileId', {
          fileId: file.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.fileList = this.fileList.filter((item) => {
              return item.uid != file.uid
            })
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if (response.errcode == 0) {
        this.fileList = fileList
        // this.fileIds.push(response.fileId);
        this.$notify.success({
          title: '上传结果',
          message: `${file.name}上传成功`,
          position: 'bottom-right'
        })
      } else {
        this.$notify.error({
          title: '上传结果',
          message: `${file.name}上传失败:${response.errmsg}`,
          position: 'bottom-right'
        })
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:{err}`,
        position: 'bottom-right'
      })
    },
    handleUpload(raw) {},
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf' || testmsg === 'PDF'
      if (!extension) {
        this.$message({
          message: '上传文件只能是pdf格式!',
          type: 'warning'
        })
      }
      return extension
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          if (index === 9) {
            sums[index] += ''
          } else {
            sums[index] = ''
          }
        } else {
          sums[index] = ''
        }
      })

      return sums
    }
  }
}
</script>

<style lang="scss" scoped>
.ComfirmOrder {
  .right_content {
    margin: 0 10px;
    height: 93%;
    background: #fff;
  }

  .title2 {
    font-size: 18px;
    border-bottom: 1px solid #95c7f0;
    padding-bottom: 7px;
    margin: 7px;
  }

  //重写el_tabs样式
  .el_tabs {
    margin: 7px 7px 0;
  }

  .el_tabs ::v-deep .el-tabs__header {
    float: none;
    margin-right: 0;
    margin-bottom: 0;

    .el-tabs__nav-wrap::after {
      background-color: #95c7f0;
    }

    .el-tabs__item {
      padding: 0 40px;
      color: #054c81;
    }

    .el-tabs__item.is-active {
      color: #fff;
      background: #2db7f5;
    }

    .el-tabs__active-bar {
      display: none;
    }
  }

  //重写el-table样式
  .el_table {
    width: 98%;
    margin: 0 auto;
    border: none;
  }

  .el_table ::v-deep .el-table__header {
    th {
      background: #d8eafa;
      text-align: center;
      border-bottom: 2px solid #e4e4e4;
      color: #333;
    }
  }

  .el_table ::v-deep .el-table__body-wrapper {
    tr {
      background-color: #e6f6fb;
    }

    td {
      text-align: center;
      border-bottom: 1px solid #e4e4e4;
      border-right: none;
      background-color: #fff;
    }
  }

  .change_inform ::v-deep.icon_tips2 {
    vertical-align: middle !important;
  }

  .changeInform_btn_wrap {
    width: 366px;
    margin: 40px auto 0;

    .btn_1 {
      background: #f60;
      border: 1px solid #f60;
      color: #fff;
      border-radius: 8px;
    }

    .btn_1:nth-of-type(1) {
      margin-right: 30px;
    }
  }

  .title2_span {
    margin-left: auto;
    color: #0660a2;
    font-weight: bold;
    font-size: 13px;
  }

  .btn {
    margin-left: 50px;
    color: #fff;
    border: 1px solid #6a96bc;
    border-radius: 5px;
    padding: 2px 18px;
    font-size: 15px;
    background: #2db7f5;
  }

  .change_inform {
    padding-top: 15px;

    .title {
      height: 34px !important;
      line-height: 40px !important;
      border-bottom: 1px solid #95c7f0 !important;
      margin-bottom: 13px;
      // padding-top: 15px !important;
    }

    ::v-deep .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: #95c7f0;
    }

    ::v-deep .table_wrap1 {
      table {
        margin: 0;

        td,
        tr,
        th {
          border-color: #95c7f0;
        }

        th {
          border-top: 1px solid #95c7f0;
          border-right: 1px solid #95c7f0;
          border-color: #95c7f0;
          background-color: #d8eafa;

          &:first-child {
            border-left: 1px solid #95c7f0;
          }
        }

        td {
          &:first-child {
            border-left: 1px solid #95c7f0;
          }
        }
      }

      .el-table__body-wrapper {
        border-bottom: 1px solid #95c7f0;
      }
    }
  }
}
</style>